export const SET_LOADING = "feed/setFeedLoading";
export const API_ERROR = "feed/API_ERROR";
export const SET_FEED = "feed/feed";
export const HIDE_USER = "feed/hideUserFromFeed";
export const HIDE_WISH = "feed/hideWishFromFeed";
export const RESET = "feed/RESET";
export const SET_LOADED_FEED_PAGE = "SetLastFeedPageLoaded";
export const SET_FEED_HAS_MORE = "SetFeedHasMorePages";
